/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BootstrapResponse } from '../models/BootstrapResponse';
import type { JourneyPhaseKind } from '../models/JourneyPhaseKind';
import type { RespondRequest } from '../models/RespondRequest';
import type { RespondResponse } from '../models/RespondResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CoachService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Initialize coach session
     * @returns BootstrapResponse Coach bootstrap state
     * @throws ApiError
     */
    public getCoachBootstrap({
        journeyPhaseOverrideKind,
    }: {
        journeyPhaseOverrideKind?: JourneyPhaseKind,
    }): CancelablePromise<BootstrapResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/coach/bootstrap',
            query: {
                'journeyPhaseOverrideKind': journeyPhaseOverrideKind,
            },
        });
    }

    /**
     * Run a coach LLM round
     * @returns RespondResponse Coach response
     * @throws ApiError
     */
    public postCoachRespond({
        requestBody,
    }: {
        requestBody?: RespondRequest,
    }): CancelablePromise<RespondResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/coach/respond',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
